import {
  PerformanceCommentCategory,
  PerformanceCommentCategoryCreateRequest,
  PerformanceCommentCategoryUpdateRequest,
} from '../../types/app/peformanceCommentCategory.types';
import { api } from '../core/api';

export const createItem = (data: PerformanceCommentCategoryCreateRequest) =>
  api.post(`PerformanceCommentCategory/CreateItem`, data).then((res) => res.data);
export const updateItem = (data: PerformanceCommentCategoryUpdateRequest) =>
  api.put(`PerformanceCommentCategory/UpdateItem`, data).then((res) => res.data);

export const deleteItem = (id: number) =>
  api.delete<PerformanceCommentCategory>(`PerformanceCommentCategory/DeleteItem/?id=${id}`).then();

export const getList = (parentId: number) =>
  api
    .get<PerformanceCommentCategory[]>(`PerformanceCommentCategory/GetList?parentId=${parentId}`)
    .then((res) => res.data);

export const getItem = (id: number) =>
  api
    .get<PerformanceCommentCategory>(`PerformanceCommentCategory/GetItem/?id=${id}`)
    .then((res) => res.data);
